import React from 'react'
import { LoadingComponent } from 'usbc-web-react-library';
import { useNavigate } from 'react-router-dom';
import AnimatedCheck from "../../../Shared/Animation/AnimatedCheck"
import useApi from '../../../../hooks/useApi'
import './Finished.css'
import { useParams } from "react-router-dom"

function Finished(props) {
    let navigate = useNavigate();

    const {
        fetchData: getRegisterationSummary,
        response: registerationSummary,
        loading: registerationSummaryLoading,
    } = useApi();

    const {
        fetchData: createPaymentIntent,
        response: paymentIntentResult,
        loading: paymentIntentisLoading,
    } = useApi();

    let { lid, season } = useParams();


    React.useEffect(() => {
        if (props.wizardState.paymentIntentId) {
            getRegisterationSummary({ url: 'getregisterationsummary/' + props.wizardState?.paymentIntentId });
        }
        else {
            createPaymentIntent({
                url: 'createpaymentintent', method: 'POST', body:
                {
                    LeagueId: lid,
                    MemberId: props.wizardState?.memberId,
                    Season: Number(season),
                    BowlerInfo: props.wizardState?.bowlerProfile
                }
            })
        }
    }, []);

    return (
        <div className='mb-3' style={{ minHeight: '400px' }}>

            <div className='finished-container d-flex justify-content-center'>
                <div style={{ width: '500px' }}>
                    <div>
                        <div className="icon-box">
                            <div className={'finished-container-icon'}>
                                <AnimatedCheck />
                            </div>
                        </div>
                        <h4 className="text-center finished-header-text fw-normal">League Registration Complete</h4>
                        <h5 className="text-center text-secondary">Thanks, You Have Successfully Registered</h5>
                    </div>
                    <div className="finished-container-body">
                        <LoadingComponent isLoading={() => registerationSummaryLoading == true || paymentIntentisLoading}>
                            <ul className="list-group">
                                <li className="list-group-item d-flex justify-content-between align-items-start">
                                    <div className="ms-2 me-auto">
                                        <div className="fw-bold">Bowler Name</div>
                                        {paymentIntentResult?.bowler?.name ? paymentIntentResult?.bowler?.name : registerationSummary?.bowlerName}
                                    </div>
                                </li>
                                <li className="list-group-item d-flex justify-content-between align-items-start">
                                    <div className="ms-2 me-auto">
                                        <div className="fw-bold">Center Name</div>
                                        {paymentIntentResult?.leagueSummary?.center?.name ? paymentIntentResult.leagueSummary?.center?.name : registerationSummary?.centerName}
                                    </div>
                                </li>
                                <li className="list-group-item d-flex justify-content-between align-items-start">
                                    <div className="ms-2 me-auto">
                                        <div className="fw-bold">League Name</div>
                                        {paymentIntentResult?.leagueSummary?.league?.name ? paymentIntentResult?.leagueSummary?.league?.name : registerationSummary?.leagueName}
                                    </div>
                                </li>
                            </ul>
                        </LoadingComponent>
                    </div>
                    <div className="finished-container-footer">
                        <button className="btn w-50 btn-primary bowl-btn" onClick={() => { navigate(0) }}>Register another bowler</button>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default Finished
